import { BaseButton } from "components";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

const ExportToExcelManifest = ({
  data,
  isCheckedParcels,
  nameTo,
  addressTo,
  nameFrom,
  reysNumber,
  addressFrom,
  ...props
}) => {
  const exportToExcel = async () => {
    const workbook = new ExcelJS.Workbook();
    const ws = workbook.addWorksheet("Manifest");

    // Column widths
    const columnWidths = [5, 18, 20, 18, 20, 12, 15, 25, 10, 15, 25];
    columnWidths.forEach((w, i) => (ws.getColumn(i + 1).width = w));

    // Header info
    ws.mergeCells("A1:F3");
    ws.getCell("A1").value = `Courier company's name and address\n${nameTo}\n${addressTo}`;
    ws.getCell("A1").alignment = { horizontal: "center", vertical: "middle", wrapText: true };
    ws.getCell("A1").font = { bold: true, size: 11 };

    ws.mergeCells("G1:K3");
    ws.getCell("G1").value = `Courier company's name and address\n${nameFrom}\n${addressFrom}`;
    ws.getCell("G1").alignment = { horizontal: "center", vertical: "middle", wrapText: true };
    ws.getCell("G1").font = { bold: true, size: 11 };

    ws.addRow([]);
    ws.mergeCells("A5:K5");
    ws.getCell("A5").value =
      "Name of documents in cargo manifest / Перечень сведений, указываемых в манифесте";
    ws.getCell("A5").alignment = { horizontal: "center", vertical: "middle", wrapText: true };
    ws.getCell("A5").font = { bold: true, size: 12 };

    ws.addRow([]);
    ws.mergeCells("A7:K7");
    ws.getCell("A7").value = `Waybill name / Номер транспортной накладной - ${reysNumber}`;
    ws.getCell("A7").alignment = { horizontal: "center", vertical: "middle", wrapText: true };
    ws.getCell("A7").font = { bold: true, size: 12 };

    ws.addRow([]);

    // Table header
    const headerRow = ws.addRow([
      "№",
      "Invoice number / Номера инфойсов",
      "Receiver's name / Ф.И.О получателя",
      "PINFL / ПИНФЛ получателя",
      "Passport number / Серия и № паспорта получателя",
      "Gross weight / Вес брутто посылки",
      "Total price / Итого цена",
      "Product name / Наименование",
      "Qty / Кол-во",
      "Price / Цена",
      "Address / Адрес",
    ]);

    headerRow.eachCell((cell) => {
      cell.font = { bold: true };
      cell.alignment = { vertical: "middle", horizontal: "center", wrapText: true };
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
    });

    // Body with merged cells
    let currentRow = ws.lastRow.number + 1;

    data.forEach((post, i) => {
      const products = Array.isArray(post.postProducts)
        ? post.postProducts.filter((p) => p.productName && p.quantity && p.price)
        : [];

      if (products.length === 0) return;

      const startRow = currentRow;
      const endRow = startRow + products.length - 1;

      const formattedWeight = Number(post.weight / 1000).toFixed(2);
      const formattedTotalPrice = Number(post.totalProductPrice).toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

      products.forEach((p) => {
        const priceFormatted = `$${p.price.toLocaleString("en-US", {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        })}`;
        ws.addRow([
          i + 1,
          post.code,
          post.receiver,
          post.pinfl,
          post.passport,
          formattedWeight,
          `$${formattedTotalPrice}`,
          p.productName,
          p.quantity,
          priceFormatted,
          post.address,
        ]);
        currentRow++;
      });

      // Merge from A→G (columns 1–7) and also K (column 11)
      ["A", "B", "C", "D", "E", "F", "G", "K"].forEach((col) => {
        if (startRow !== endRow) {
          ws.mergeCells(`${col}${startRow}:${col}${endRow}`);
          const mergedCell = ws.getCell(`${col}${startRow}`);
          mergedCell.alignment = { vertical: "middle", horizontal: "center", wrapText: true };
        }
      });
    });

    // Total
    const totalWeight = data.reduce((sum, x) => sum + (parseFloat(x.weight) || 0), 0);
    const totalPrice = data.reduce((sum, p) => sum + (p.totalProductPrice || 0), 0);

    const totalRow = ws.addRow([
      "Total",
      "",
      "",
      "",
      "",
      (totalWeight / 1000).toFixed(2),
      `$${totalPrice.toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`,
      "",
      "",
      "",
      "",
    ]);

    totalRow.eachCell((cell) => {
      cell.font = { bold: true };
      cell.alignment = { horizontal: "center", vertical: "middle" };
      cell.border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };
    });

    ws.addRow([]);
    const signRow = ws.addRow(["SIGNATURE AND STAMP / ПОДПИСЬ И ПЕЧАТЬ"]);
    ws.mergeCells(`A${signRow.number}:K${signRow.number}`);
    const descRow = ws.addRow(["Description / Примечание: __________________________"]);
    ws.mergeCells(`A${descRow.number}:K${descRow.number}`);

    const buffer = await workbook.xlsx.writeBuffer();
    saveAs(new Blob([buffer]), "manifest.xlsx");
  };

  return (
    <BaseButton
      {...props}
      handleClick={() => exportToExcel()}
      bordered
      disabled={!isCheckedParcels}
      style={
        !isCheckedParcels
          ? { color: "#B3B3B3", border: "solid 2px #B3B3B3" }
          : {}
      }
    >
      Export Excel
    </BaseButton>
  );
};

export default ExportToExcelManifest;
